// Mock data for artist landing page

export const artistInfo = {
  name: "Martin Fowler",
  tagline: "Contemporary Political Artist",
  quote: "In the dark times\nWill there also be singing?\nYes, there will also be singing.\nAbout the dark times.",
  quoteAuthor: "Bertolt Brecht",
  statement: "Grounded in Gramsci's theory of 'knowing thyself as a product of the historical process to date', Fowler's acerbic critical-realist image-making challenges received notions of the neoliberal institution, State power and political violence.",
  bio: "Martin Fowler is a contemporary fine artist whose politically charged drawings and paintings challenge conventional narratives. Grounded in Gramsci's theory of 'knowing thyself as a product of the historical process to date', Fowler's acerbic critical-realist image-making challenges received notions of the neoliberal institution, State power and political violence. Working primarily in charcoal, ink, and acrylics, Fowler's distinctive style combines raw emotional intensity with meticulous technical precision.",
  email: "martifowler@hotmail.com",
  social: {
    instagram: "@martinfowler.art",
    twitter: "@mfowler_art"
  }
};

export const featuredWorks = [
  {
    id: 1,
    title: "Voices Unheard",
    year: 2024,
    medium: "Charcoal on canvas",
    dimensions: "48 x 36 inches",
    description: "An exploration of marginalized communities and their struggle for representation in modern political discourse.",
    image: "https://images.unsplash.com/photo-1578301978018-3005759f48f7?w=800&q=80"
  },
  {
    id: 2,
    title: "The Weight of Power",
    year: 2024,
    medium: "Acrylic and ink on canvas",
    dimensions: "60 x 40 inches",
    description: "A visceral commentary on authoritarian structures and the human cost of unchecked political authority.",
    image: "https://images.unsplash.com/photo-1547826039-bfc35e0f1ea8?w=800&q=80"
  },
  {
    id: 3,
    title: "Borders and Bodies",
    year: 2023,
    medium: "Mixed media on paper",
    dimensions: "40 x 30 inches",
    description: "A series examining immigration, displacement, and the arbitrary nature of national boundaries.",
    image: "https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=800&q=80"
  },
  {
    id: 4,
    title: "Silent Protest",
    year: 2023,
    medium: "Charcoal and conte on canvas",
    dimensions: "52 x 38 inches",
    description: "Capturing the quiet resistance of individuals standing against oppressive systems.",
    image: "https://images.unsplash.com/photo-1577083552431-6e5fd01988ec?w=800&q=80"
  },
  {
    id: 5,
    title: "Democracy in Fragments",
    year: 2023,
    medium: "Acrylic on canvas",
    dimensions: "48 x 48 inches",
    description: "A reflection on the fragility of democratic institutions in contemporary society.",
    image: "https://images.unsplash.com/photo-1536924940846-227afb31e2a5?w=800&q=80"
  },
  {
    id: 6,
    title: "Collective Memory",
    year: 2022,
    medium: "Ink and charcoal on paper",
    dimensions: "36 x 24 inches",
    description: "An investigation into how societies remember and forget their political histories.",
    image: "https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=800&q=80"
  }
];

export const exhibitions = [
  {
    id: 1,
    title: "Systems of Control",
    venue: "Contemporary Art Museum, New York",
    type: "Solo Exhibition",
    date: "March 2024 - June 2024",
    description: "A comprehensive survey of recent works exploring themes of surveillance, authority, and resistance."
  },
  {
    id: 2,
    title: "Political Bodies",
    venue: "Tate Modern, London",
    type: "Group Exhibition",
    date: "September 2023 - January 2024",
    description: "Featured alongside prominent contemporary artists examining the body politic."
  },
  {
    id: 3,
    title: "Dissent and Dialogue",
    venue: "Berlin Kunsthalle, Germany",
    type: "Solo Exhibition",
    date: "May 2023 - August 2023",
    description: "A provocative collection addressing free speech and political expression."
  },
  {
    id: 4,
    title: "Borders: A Global Perspective",
    venue: "MoMA PS1, New York",
    type: "Group Exhibition",
    date: "October 2022 - February 2023",
    description: "International artists respond to migration and border politics."
  }
];
